import { render } from "./OfferDetailsPageV2.vue?vue&type=template&id=657842d9"
import script from "./OfferDetailsPageV2.vue?vue&type=script&lang=js"
export * from "./OfferDetailsPageV2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__